/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_StorageInputs */

const en_svchip_storage = /** @type {(inputs: Svchip_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storage`)
};

const ar_svchip_storage = /** @type {(inputs: Svchip_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التخزين`)
};

const bn_svchip_storage = /** @type {(inputs: Svchip_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্টোরেজ`)
};

const de_svchip_storage = /** @type {(inputs: Svchip_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speicher`)
};

const es_svchip_storage = /** @type {(inputs: Svchip_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almacenamiento`)
};

const fr_svchip_storage = /** @type {(inputs: Svchip_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stockage`)
};

const pt_svchip_storage = /** @type {(inputs: Svchip_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armazenamento`)
};

const zh_svchip_storage = /** @type {(inputs: Svchip_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`存储`)
};

const tr_svchip_storage = /** @type {(inputs: Svchip_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depolama`)
};

const ru_svchip_storage = /** @type {(inputs: Svchip_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хранение`)
};

const pl_svchip_storage = /** @type {(inputs: Svchip_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przechowywanie`)
};

/**
* | output |
* | --- |
* | "Storage" |
*
* @param {Svchip_StorageInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_storage = /** @type {((inputs?: Svchip_StorageInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_StorageInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_storage(inputs)
	if (locale === "bn") return bn_svchip_storage(inputs)
	if (locale === "de") return de_svchip_storage(inputs)
	if (locale === "es") return es_svchip_storage(inputs)
	if (locale === "fr") return fr_svchip_storage(inputs)
	if (locale === "pt") return pt_svchip_storage(inputs)
	if (locale === "zh") return zh_svchip_storage(inputs)
	if (locale === "tr") return tr_svchip_storage(inputs)
	if (locale === "ru") return ru_svchip_storage(inputs)
	if (locale === "pl") return pl_svchip_storage(inputs)
	return en_svchip_storage(inputs)
});